import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';
import { ITargetEntity } from '../../../APIPackage/DictionariesModule/interfaces/ITargetEntity';

export const createDictionaryTargetEntitySelectOption = makeCreateDictionarySelectOption<ITargetEntity>(
  'title',
  'title',
);
